import { Component, Input, ElementRef } from '@angular/core'
import { ClientDetailsProvider } from '../../providers/client-details/client-details'
import { ConfigProvider } from '../../providers/config/config';
import { AppState } from '../../config/state';

@Component({
  selector: 'co-widget',
  templateUrl: 'co-widget.html'
})

export class CoWidgetComponent {
  @Input() widgetId: number;
  @Input() cssRules: any = {};
  @Input() widget: any;
  private clientKeyword: string
  private widgetUrl: string

  constructor(private clientDetails: ClientDetailsProvider, private config:ConfigProvider, private el: ElementRef, private state : AppState) {
    this.widgetUrl="";
  }
  ngAfterViewInit(){
    if(this.cssRules){
      Object.keys(this.cssRules).forEach((key) => {
        let value = this.cssRules[key];
        // this.el.nativeElement.style[key]=value;
        this.el.nativeElement.style.setProperty(key, value, 'important');
      });
    }
  }
  ngOnInit() {
    this.config.load(this.state.appId).then(cfg => {
      this.clientDetails.load().then((data) => {
        this.clientKeyword = data.keyword;
          this.widgetUrl = "https://" + this.clientKeyword + ".libnet.info/widget?bodyonly=true&id=" + this.widgetId + "&style=" + cfg.theme.id;
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/co-widget/co-widget.ts